import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER,
  INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA,
  INCIDENT_DETAILS_SET_FORCE_VALIDATION,
} from '../../../../actions/actionTypes';

const defaultState = {
  isValidAccount: true,
  isValidCommonLinkData: true,
  isValidEvidence: true,
  isValidLinkImageList: true,
  isValidLinkPriceList: true,
  isValidMultimediaFileLinkData: true,
  isValidOfferListingLinkData: true,
  isValidOverallMultimediaLinkData: true,
  isValidProductListingLinkData: true,
  isValidSeller: true,
  isValidSocialMediaLinkData: true,
};

const detectionLinkValidation = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_ACCOUNT:
      return {
        ...state,
        isValidAccount: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_COMMON_LINK_DATA:
      return {
        ...state,
        isValidCommonLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_EVIDENCE:
      return {
        ...state,
        isValidEvidence: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_IMAGE_LIST:
      return {
        ...state,
        isValidLinkImageList: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_LINK_PRICE_LIST:
      return {
        ...state,
        isValidLinkPriceList: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_MULTIMEDIA_FILE_LINK_DATA:
      return {
        ...state,
        isValidMultimediaFileLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OFFER_LISTING_LINK_DATA:
      return {
        ...state,
        isValidOfferListingLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_OVERALL_MULTIMEDIA_LINK_DATA:
      return {
        ...state,
        isValidOverallMultimediaLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_PRODUCT_LISTING_LINK_DATA:
      return {
        ...state,
        isValidProductListingLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SELLER:
      return {
        ...state,
        isValidSeller: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_CONTENT_LINK_VALIDATION_SOCIAL_MEDIA_LINK_DATA:
      return {
        ...state,
        isValidSocialMediaLinkData: action.payload.isValid,
      };

    case INCIDENT_DETAILS_SET_FORCE_VALIDATION:
      return {
        ...state,
        ...action.payload.contentLinkInitialValidationState,
      };

    case INCIDENT_DETAILS_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default detectionLinkValidation;

export const getIncidentDetailsContentLinkIsValid = ({
  isValidAccount,
  isValidCommonLinkData,
  isValidEvidence,
  isValidLinkImageList,
  isValidLinkPriceList,
  isValidMultimediaFileLinkData,
  isValidOfferListingLinkData,
  isValidOverallMultimediaLinkData,
  isValidProductListingLinkData,
  isValidSeller,
  isValidSocialMediaLinkData,
}) =>
  Boolean(
    isValidAccount &&
      isValidCommonLinkData &&
      isValidEvidence &&
      isValidLinkImageList &&
      isValidLinkPriceList &&
      isValidMultimediaFileLinkData &&
      isValidOfferListingLinkData &&
      isValidOverallMultimediaLinkData &&
      isValidProductListingLinkData &&
      isValidSeller &&
      isValidSocialMediaLinkData
  );

export const getIncidentDetailsContentLinkIsValidating = (
  state,
  forceValidation
) => forceValidation || Object.values(state).some(isValid => isValid === null);

export const getIncidentDetailsContentLinkValidationInitialState = ({
  hasEvidence,
  hasLinkMetadataAccount,
  hasLinkMetadataCommon,
  hasLinkMetadataLinkImage,
  hasLinkMetadataLinkPrice,
  hasLinkMetadataMultimediaFile,
  hasLinkMetadataOfferListing,
  hasLinkMetadataOverallMultimedia,
  hasLinkMetadataProductListing,
  hasLinkMetadataSeller,
  hasLinkMetadataSocialMedia,
}) => ({
  isValidAccount: hasLinkMetadataAccount ? null : true,
  isValidCommonLinkData: hasLinkMetadataCommon ? null : true,
  isValidEvidence: hasEvidence ? null : true,
  isValidLinkImageList: hasLinkMetadataLinkImage ? null : true,
  isValidLinkPriceList: hasLinkMetadataLinkPrice ? null : true,
  isValidMultimediaFileLinkData: hasLinkMetadataMultimediaFile ? null : true,
  isValidOfferListingLinkData: hasLinkMetadataOfferListing ? null : true,
  isValidOverallMultimediaLinkData: hasLinkMetadataOverallMultimedia
    ? null
    : true,
  isValidProductListingLinkData: hasLinkMetadataProductListing ? null : true,
  isValidSeller: hasLinkMetadataSeller ? null : true,
  isValidSocialMediaLinkData: hasLinkMetadataSocialMedia ? null : true,
});
